import { useGetApiWorkspacesByIdDataConsoleQuery } from '@/model/dataConsole/api.generated';
import { useTrans } from '@/shared/hooks/useTranslation';
import { toConsoleView } from '@/viewmodel/features/dataConsole/mappers/consoleView';
import type { ConsoleView } from '@/viewmodel/features/dataConsole/types';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { useMemo } from 'react';

export function useDataConsole(workspaceId: string | undefined): {
  view: ConsoleView;
  isLoading: boolean;
  isError: boolean;
} {
  const { data, isLoading, isError } = useGetApiWorkspacesByIdDataConsoleQuery(
    workspaceId ? { id: workspaceId } : skipToken,
    { refetchOnMountOrArgChange: true },
  );
  const { t } = useTrans();
  const storeName = t('dataConsole.store.name');
  const view = useMemo(() => toConsoleView(data?.['data'], storeName), [data, storeName]);

  return { view, isLoading, isError };
}
